var React = require('react');

function Started (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.71757 6.67021C8.73581 6.4331 8.93353 6.25 9.17135 6.25C9.40517 6.25 9.60094 6.42718 9.62421 6.65983L9.99989 10.4167L12.6943 11.9564C12.8318 12.0349 12.9166 12.181 12.9166 12.3393C12.9166 12.6301 12.6401 12.8413 12.3595 12.7647L8.73189 11.7754C8.50051 11.7123 8.34653 11.4938 8.36492 11.2547L8.71757 6.67021Z","fill":"black","key":0}),React.createElement("path",{"opacity":"0.3","fillRule":"evenodd","clipRule":"evenodd","d":"M5.27414 1.30874C5.01004 0.993996 4.5001 1.11447 4.40476 1.51413L3.52874 5.18676C3.45107 5.51241 3.70914 5.82091 4.04339 5.80197L7.82147 5.58787C8.23237 5.56459 8.44075 5.08256 8.1762 4.76728L7.29076 3.71206C8.0188 3.46328 8.7908 3.33334 9.5835 3.33334C13.4955 3.33334 16.6668 6.50466 16.6668 10.4167C16.6668 14.3287 13.4955 17.5 9.5835 17.5C5.67148 17.5 2.50016 14.3287 2.50016 10.4167C2.50016 9.75995 2.5891 9.11673 2.76251 8.49852L1.15777 8.04839C0.946492 8.80162 0.833496 9.59595 0.833496 10.4167C0.833496 15.2492 4.751 19.1667 9.5835 19.1667C14.416 19.1667 18.3335 15.2492 18.3335 10.4167C18.3335 5.58418 14.416 1.66667 9.5835 1.66667C8.36795 1.66667 7.2103 1.91453 6.15833 2.36247L5.27414 1.30874Z","fill":"black","key":1})]);
}

Started.displayName = "Started";

Started.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Started;

Started.default = Started;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/started.svg
// module id = 1683
// module chunks = 0